import { render } from "./experience-again-button.vue?vue&type=template&id=b4ec8a4e&scoped=true"
import script from "./experience-again-button.vue?vue&type=script&lang=js"
export * from "./experience-again-button.vue?vue&type=script&lang=js"

import "./experience-again-button.vue?vue&type=style&index=0&id=b4ec8a4e&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/hkust-gz-vitals/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4ec8a4e"]])

export default __exports__